import {
    Card,
    Descriptions,
    Drawer,
    Row,
    Col,
    Typography,
    Divider
}
    from "antd";

export default function AgreementCard({
                                            conversation
                                        }) {

    const {
        product
    } = conversation;

    return (
        <Card
            style={{
                background:"#f6ffed"
            }}
        >

            <Typography.Title level={5}>
                🤝 Accord trouvé
            </Typography.Title>

            <Descriptions column={1}>

                <Descriptions.Item label="Prix">
                    16 000 FCFA
                </Descriptions.Item>

                <Descriptions.Item label="Quantité">
                    25 Kg
                </Descriptions.Item>

                <Descriptions.Item label="Nombre acheté">
                    4 paquets
                </Descriptions.Item>

            </Descriptions>

        </Card>

    );
}